import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M19 10h-14","key":"svg-0"}],["path",{"d":"M5 6h14","key":"svg-1"}],["path",{"d":"M14 14h-9","key":"svg-2"}],["path",{"d":"M5 18h6","key":"svg-3"}],["path",{"d":"M18 15v6","key":"svg-4"}],["path",{"d":"M15 18h6","key":"svg-5"}]]

const IconTextPlus = createReactComponent('outline', 'text-plus', 'TextPlus', __iconNode);

export default IconTextPlus;